/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Bring_EyebrowInputs */

const en_funnel_ob_bring_eyebrow = /** @type {(inputs: Funnel_Ob_Bring_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It reads it all`)
};

const es_funnel_ob_bring_eyebrow = /** @type {(inputs: Funnel_Ob_Bring_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo lee todo`)
};

/**
* | output |
* | --- |
* | "It reads it all" |
*
* @param {Funnel_Ob_Bring_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_bring_eyebrow = /** @type {((inputs?: Funnel_Ob_Bring_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Bring_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_bring_eyebrow(inputs)
	return en_funnel_ob_bring_eyebrow(inputs)
});